import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#136485";
function DCN({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  fillRule="evenodd" d="M7.827 23.255a12 12 0 01-4.203-2.661l.11-.193c1.791-2.83 3.4-5.759 4.611-8.888 1.285-3.318 2.313-6.725 3.293-10.145.088-.305.192-.605.288-.908a.8.8 0 01.172.341c.615 2.194 1.21 4.395 1.848 6.582 1.163 3.985 2.798 7.765 4.963 11.308q.38.62 1.29 2.071a12 12 0 01-4.526 2.666A3246 3246 0 0011.92 12.05l-.115-.001q-1.312 3.686-3.979 11.206M12.057.037h-.094L12 0z" clipRule="evenodd" /><path  fillRule="evenodd" d="M7.827 23.255a12 12 0 01-4.203-2.661l.11-.193c1.791-2.83 3.4-5.759 4.611-8.888 1.285-3.318 2.313-6.725 3.293-10.145.088-.305.192-.605.288-.908a.8.8 0 01.172.341c.615 2.194 1.21 4.395 1.848 6.582 1.163 3.985 2.798 7.765 4.963 11.308q.38.62 1.29 2.071a12 12 0 01-4.526 2.666A3246 3246 0 0011.92 12.05l-.115-.001q-1.312 3.686-3.979 11.206M12.057.037h-.094L12 0z" clipRule="evenodd" /></Svg>;
}
DCN.DefaultColor = DefaultColor;
export default DCN;